module.exports = __webpack_public_path__ + "static/team-messaging-web-app-plp-f8fabb9ec68356221f0082fbf9258ee4.png";